import { createFileRoute } from "@tanstack/react-router";

import { PageHero, Prose } from "@/components/site/Page";
import { SubscribeForm } from "@/components/site/SubscribeForm";
import { seoLinks, ogImage } from "@/lib/seo";

const TITLE = "Suscríbete al boletín y al blog | SIS Estepona";
const DESCRIPTION =
  "Recibe el boletín del colegio y las nuevas entradas del blog de Swedish International School en Estepona directamente en tu correo.";

export const Route = createFileRoute("/es/suscribirse")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "es_ES" },
      ...ogImage(),
    ],
    links: seoLinks("/es/suscribirse"),
  }),
  component: SuscribirsePage,
});

function SuscribirsePage() {
  return (
    <>
      <PageHero
        eyebrow="Suscripción"
        title="Mantente al día del colegio"
        intro="Boletines y entradas del blog sobre la enseñanza, la vida escolar y cuestiones prácticas para familias en la Costa del Sol."
      />

      <div className="mx-auto max-w-3xl px-5 py-10 sm:py-14">
        <SubscribeForm locale="es" source="/es/suscribirse" />
      </div>

      <Prose>
        <h2>Qué recibes</h2>
        <p>
          El boletín se envía algunas veces por periodo y reúne lo que viene: fechas importantes,
          novedades del colegio y cosas útiles antes de empezar. Si eliges las entradas del blog,
          recibirás un correo cada vez que publiquemos un artículo nuevo.
        </p>
        <h2>Cómo tratamos tu dirección</h2>
        <p>
          Tu correo electrónico se guarda en el colegio y se usa únicamente para los envíos que hayas
          elegido. Nunca vendemos ni compartimos la lista. Cada correo incluye un enlace para cambiar
          tus preferencias o cancelar la suscripción sin necesidad de contactarnos.
        </p>
      </Prose>
    </>
  );
}
